<form
  [formGroup]="categoryEditForm"
  (ngSubmit)="onSubmit()"
  novalidate
  #pform="ngForm"
>
  <div class="animated fadeIn">
    <div class="col mb-2">
      <span class="mr-2">Active </span>
      <label class="switch switch-lg switch-3d switch-primary">
        <input
          type="checkbox"
          class="switch-input"
          formControlName="isActive"
        />
        <span class="switch-label"></span>
        <span class="switch-handle"></span>
      </label>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Basic information
            <button type="submit" class="btn btn-sm btn-primary float-right">
              <i class="fa fa-save"></i> Submit
            </button>
            <button
              type="button"
              class="btn btn-sm btn-warning float-right mr-2"
              (click)="onCancel()"
            >
              <i class="fa fa-ban"></i> Cancel
            </button>
            <button
              type="button"
              class="btn btn-sm btn-secondary float-right mr-2"
              [routerLink]="['/distributors/sub-categories/list']"
            >
              <i class="fa fa-arrow-left"></i> Subcategories list
            </button>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label for="title">Title</label>
              <input
                type="text"
                class="form-control"
                id="title"
                formControlName="title"
              />
              <div
                *ngIf="
                  title.invalid &&
                  (title.dirty || title.touched || pform.submitted)
                "
                class="alert alert-danger"
              >
                <div *ngIf="title.errors.required">Title is required.</div>
              </div>
            </div>
            <div class="form-group">
              <label for="info">Main Category</label>
              <select class="form-control" formControlName="parentId" required>
                <option
                  *ngFor="let category of categories"
                  [value]="category.id"
                >
                  {{ category.title }}
                </option>
              </select>
              <div
                *ngIf="
                  parentId.invalid &&
                  (parentId.dirty || parentId.touched || pform.submitted)
                "
                class="alert alert-danger"
              >
                <div *ngIf="blogMainCategoriesId.errors.required">
                  Category is required.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="info">Link name</label>
              <select class="form-control" formControlName="linkName" required>
                <option *ngFor="let item of linkNames" [value]="item.value">
                  {{ item.label }}
                </option>
              </select>
              <div
                *ngIf="
                  linkName.invalid &&
                  (linkName.dirty || linkName.touched || pform.submitted)
                "
                class="alert alert-danger"
              >
                <div *ngIf="linkName.errors.required">
                  Link name is required.
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="order">Order</label>
              <input
                type="number"
                class="form-control"
                id="order"
                min="0"
                formControlName="order"
              />
            </div>

            <div class="form-group">
              <label for="lead">Main image</label>
              <div class="row">
                <div class="col-6"></div>
                <div class="col-6"></div>
              </div>
              <div id="qq-template" hidden>
                <div
                  class="qq-uploader-selector qq-uploader"
                  qq-drop-area-text="Drop files here"
                >
                  <div
                    class="qq-total-progress-bar-container-selector qq-total-progress-bar-container"
                  >
                    <div
                      role="progressbar"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      class="qq-total-progress-bar-selector qq-progress-bar qq-total-progress-bar"
                    ></div>
                  </div>
                  <div
                    class="qq-upload-drop-area-selector qq-upload-drop-area"
                    qq-hide-dropzone
                  >
                    <span class="qq-upload-drop-area-text-selector"></span>
                  </div>
                  <div class="buttons">
                    <div class="qq-upload-button-selector qq-upload-button">
                      <div>Select file</div>
                    </div>
                  </div>
                  <span class="qq-drop-processing-selector qq-drop-processing">
                    <span>Processing dropped files...</span>
                    <span
                      class="qq-drop-processing-spinner-selector qq-drop-processing-spinner"
                    ></span>
                  </span>
                  <ul
                    class="qq-upload-list-selector qq-upload-list"
                    aria-live="polite"
                    aria-relevant="additions removals"
                  >
                    <li>
                      <div class="qq-progress-bar-container-selector">
                        <div
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          class="qq-progress-bar-selector qq-progress-bar"
                        ></div>
                      </div>
                      <span
                        class="qq-upload-spinner-selector qq-upload-spinner"
                      ></span>
                      <img
                        class="qq-thumbnail-selector"
                        qq-max-size="100"
                        qq-server-scale
                      />
                      <span
                        class="qq-upload-file-selector qq-upload-file"
                      ></span>
                      <span
                        class="qq-edit-filename-icon-selector qq-edit-filename-icon"
                        aria-label="Edit filename"
                      ></span>
                      <input
                        class="qq-edit-filename-selector qq-edit-filename"
                        tabindex="0"
                        type="text"
                      />
                      <span
                        class="qq-upload-size-selector qq-upload-size"
                      ></span>
                      <span
                        role="status"
                        class="qq-upload-status-text-selector qq-upload-status-text"
                      ></span>
                    </li>
                  </ul>
                </div>
              </div>
              <sub-category-main-image
                *ngIf="subCategory"
                divId="album-documents"
                (eventImage)="setMainImage($event)"
                [image]="subCategory.mainImageSrc"
                [categoryId]="subCategory.id"
                fileType="3"
              >
              </sub-category-main-image>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-header">Category description</div>
          <div class="card-body">
            <angular-tinymce formControlName="description"></angular-tinymce>
            <div
              *ngIf="
                description.invalid &&
                (description.dirty || description.touched || pform.submitted)
              "
              class="alert alert-danger"
            >
              <div *ngIf="description.errors.required">
                Description is required.
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-footer">
            <button
              type="reset"
              class="btn btn-sm btn-danger"
              (click)="onCancel()"
            >
              <i class="fa fa-ban"></i> Cancel
            </button>
            <button type="submit" class="btn btn-sm btn-primary">
              <i class="fa fa-dot-circle-o"></i> Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
